import { Ident } from '@mode-switch/express';
export var DomainQuery;
(function (DomainQuery) {
    let Type;
    (function (Type) {
        Type["Pivot"] = "PIVOT";
        Type["Table"] = "TABLE";
    })(Type = DomainQuery.Type || (DomainQuery.Type = {}));
    let Table;
    (function (Table) {
        function make(domain) {
            const id = Ident.next();
            const { fields } = domain;
            return { id, fields: fields || [], type: "TABLE" };
        }
        Table.make = make;
    })(Table = DomainQuery.Table || (DomainQuery.Table = {}));
    let Pivot;
    (function (Pivot) {
        function make(query, domain) {
            const id = Ident.next();
            const { fields } = domain;
            return { id, query, fields: fields || [], type: "PIVOT" };
        }
        Pivot.make = make;
    })(Pivot = DomainQuery.Pivot || (DomainQuery.Pivot = {}));
})(DomainQuery || (DomainQuery = {}));
